import axios from 'axios';
import {KRBS_TONS} from '../../config/constanst.config';
import {AppService} from '../../service/app.service';
import {AlertService} from '../../service/alert.service';
import {commit} from 'lodash/seq';
import {fas} from '@fortawesome/free-solid-svg-icons';

const initFormObjCrewKeys = () => {
  return {
    searchVal: null,
    searchKey: 'all',
    page: null,
    count: 10, // default
  };
};

const initFormDataVesselTon = () => {
  return {
    searchVal: null,
    manningId: null,
    vesselType: null,
    count: 10,
    page: 1,
  };
};

const initFormTonPayload = () => {
  return {
    rankId: null,
    manningId: null,
    vesselId: null,
    sFirstName: "",
    sMiddleName: "",
    sLastName: "",
    page: null,
    assignedType : 1,
  };
};

const initformNewCrewTon = () => {
  return {
    assignedBy: "",
    assignedTo: "",
    rankId: "",
    vesselId: "",
    manningId: "",
    remarks: "",
    file: "",
    renewFrom: null,
  };
};

const initUploadReplaceFile = () => {
  return {
    file: null,
    remarks: null,
    crewTonId: null,
  };
};

/** state **/
const state = {
  crewTon: {},
  crewTons: [],
  formObjCrewKeys: initFormObjCrewKeys(),
  formDataVesselTon: initFormDataVesselTon(),
  formTonPayload: initFormTonPayload(),
  formNewCrewTon: initformNewCrewTon(),
  isSearchingCrew: false,

  formTonUploadReplaceFile: initUploadReplaceFile(),

  crewTonId : null,
  downloadPercent: null,
  uploadPercent: null,
  vesselId : null,
};

/** mutations **/
const mutations = {
  set_crew_ton(state, payload) {
    state.crewTon = payload;
  },

  set_crew_tons(state, payload) {
    state.crewTons = payload;
  },

  set_ton_payload_rank(state, payload) {
    // console.log('Test im setting ton payload rank.....', payload);
    state.formTonPayload.rankId = Number.parseInt(payload, 10);
  },

  set_is_searching_crew(state, payload) {
    state.isSearchingCrew = payload;
  },

  set_download_percent(state, payload) {
    state.downloadPercent = payload;
  },

  set_upload_percent(state, payload) {
    state.uploadPercent = payload;
  },

  update_crew_ton_data(state, payload) {
    let crewTon = state.crewTon.data.find((val, index) => val.crewTonId === payload.crewTonId);
    Object.assign(crewTon, payload);
  },

  reset_crew_ton(state) {
    state.crewTon = {};
  },

  reset_crew_tons(state) {
    state.crewTons = [];
  },

  reset_form_obj_crew_keys(state) {
    Object.assign(state.formObjCrewKeys, initFormObjCrewKeys());
  },

  reset_form_data_vessel_ton(state) {
    Object.assign(state.formDataVesselTon, initFormDataVesselTon());
  },

  reset_form_ton_payload(state) {
    Object.assign(state.formTonPayload, initFormTonPayload());
  },

  reset_form_new_crew_ton(state) {
    Object.assign(state.formNewCrewTon, initformNewCrewTon());
  },

  reset_form_ton_upload_replace_file(state) {
    Object.assign(state.formTonUploadReplaceFile, initUploadReplaceFile());
  },

  set_crew_ton_id(state,payload){
    state.crewTonId = payload;
  },

  reset_crew_ton_id(state){
    state.crewTonId = {};
  },

};

/** actions **/
const actions = {
  async getVesselList({commit}, payload) {
    commit('set_is_loading', true);
    let url = null;
    let authPos = AppService.originalState('auth', 'authPos');
    switch (authPos.id) {
      case 2:
        url = KRBS_TONS.USER_GET_VESSEL;
        break;

      case 1:
      case 3:
      case 4:
        url = KRBS_TONS.STAFF_GET_VESSEL;
        break;

      default:
        break;
    }

    return await axios.post(`${url}`, payload).then((r) => {
      commit('set_is_loading', false);
      commit('set_vessel_type_keys', r.data.vesselTypeKeys);
      commit('set_manning_keys', r.data.manningKeys);
      commit('set_vessels', r.data.vessels.data);
      commit('set_vessel_paginated', r.data.vessels);
      return true;

    }).catch((er) => {
      commit('set_is_loading', false);
      AlertService.responseAlertMessage(er, 'Get vessel list');
      return false;

    });
  },

  async getVesselCrewTons({commit}, payload) {
    commit('set_is_loading', true);
    let url = null;
    let authPos = AppService.originalState('auth', 'authPos');

    switch (authPos.id) {
      case 2:
        url = KRBS_TONS.USER_GET_VESSEL_CREW_TONS;
        break;

      case 1:
      case 3:
      case 4:
        url = KRBS_TONS.STAFF_GET_VESSEL_CREW_TONS;
        break;

      default:
        break;
    }

    return await axios.post(`${url}/${payload.vesselId}`, payload).
        then((r) => {
          // console.log('Test demo crew ton',r.data);
          commit('set_is_loading', false);
          commit('set_crew_ton', r.data);
          commit('set_rank_keys',r.data.rankKeys)
          return true;
        }).catch((er) => {
          commit('set_is_loading', false);
          // console.log(er);
          return false;
        });
  },

  async getCrewKeysPaginated({commit}, payload) {
    commit('set_is_searching_crew', true);
    return await axios.post(KRBS_TONS.STAFF_GET_CREW_KEY_PAGINATED, payload).then((r) => {
      commit('set_is_searching_crew', false);
      commit('set_obj_crew_keys_pagination', r.data);
      commit('set_crew_keys', r.data.data);
      return true;

    }).catch((er) => {

      commit('set_is_searching_crew', false);
      AlertService.responseAlertMessage(er, 'Get crew paginated');
      return false;
    });
  },

  createCrewTon({commit}, payload) {
    commit('set_is_loading', true);
    return axios({
      method: 'post',
      url: `${KRBS_TONS.STAFF_CREATE_CREW_TON}`,
      data: payload,
      'Content-Type': 'multipart/form-data',
      maxContentLength: 10000000,
      maxBodyLength: 10000000,

    }).then((r) => {
      commit('set_is_loading', false);
      return true;

    }).catch((er) => {
      commit('set_is_loading', false);
      AlertService.responseAlertMessage(er, 'Create Crew Ton');
      return false;

    });
  },


  /** routes for crew **/
 async viewCrewTon({commit},payload){
   commit('set_is_loading',true)
    return await axios.get(`${KRBS_TONS.CREW_VIEW_CREW_TON}/${payload}`).then((r)=>{
      commit('set_crew_ton',r.data)
      commit('set_is_loading',false)
      return true;
    }).catch((er)=>{
      commit('set_is_loading',false)
      AlertService.responseAlertMessage(er,'View crewton')
      return false;
    })
  },

  deleteCrewTon({commit}, payload) {
    commit('set_is_loading', true);
    return axios.delete(`${KRBS_TONS.STAFF_DELETE_CREW_TON}/${payload}`).then((r) => {
      commit('set_is_loading', false);
      return true;
    }).catch((er) => {
      commit('set_is_loading', false);
      AlertService.responseAlertMessage(er, 'Delete ton record');
      return false;

    });
  },

  updateCrewTon({commit}, payload) {
    return axios.post(KRBS_TONS.STAFF_UPDATE_CREW_TON, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        maxContentLength: 10000000,
        maxBodyLength: 10000000,
      },
      onUploadProgress: progressEvent => {
        let percentComplete = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        commit('set_upload_percent', percentComplete);
      },
    }).then((r) => {
      commit('update_crew_ton_data', r.data);
      commit('set_upload_percent', 0);
      return true;

    }).catch((er) => {
      AlertService.responseAlertMessage(er, 'Update crewton');
      return false;

    });
  },

  async downloadTonFile({commit}, payload) {
    let authPos = AppService.originalState('auth', 'authPos');
    let url = null;

    switch (authPos.id) {
      case 2:
        url = KRBS_TONS.USER_DOWNLOAD_CREW_TON;
        break;

      case 1:
      case 3:
      case 4:
        url = KRBS_TONS.STAFF_DOWNLOAD_CREW_TON;
        break;

      case 5:
        url = KRBS_TONS.CREW_DOWNLOAD_CREW_TON;
        break;

    }
    return await axios.post(url, payload, {
      responseType: 'blob',
      onDownloadProgress: progressEvent => {
        let percentComplete = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        commit('set_download_percent', percentComplete);
      },

    }).then((r) => {
      const url = URL.createObjectURL(new Blob([r.data], {
        type: r.data.type,
      }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${payload.fileName}`);
      document.body.appendChild(link);
      link.click();
      commit('set_download_percent', 0);
      return true;
    }).catch((er) => {
      commit('set_upload_percent', 0);
      AlertService.responseAlertMessage(er, 'Download TON');
      return false;
    });
  },

  uploadCrewTonFile({commit}, payload) {
    return axios.post(KRBS_TONS.STAFF_UPLOAD_CREW_TON, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        maxContentLength: 10000000,
        maxBodyLength: 10000000,
      },
      onUploadProgress: progressEvent => {
        let percentComplete = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        commit('set_upload_percent', percentComplete);
      },
    }).then((r) => {
      commit('set_upload_percent', 0);
      commit('update_crew_ton_data',r.data)
      return true;

    }).catch((er) => {
      commit('set_upload_percent', 0);
      AlertService.responseAlertMessage(er, 'Upload crew ton file');
      return false;
    });
  },

  replaceCrewTonFile({commit}, payload) {
    return axios.post(KRBS_TONS.STAFF_REPLACE_CREW_TON, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        maxContentLength: 10000000,
        maxBodyLength: 10000000,
      },
      onUploadProgress: progressEvent => {
        let percentComplete = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        commit('set_upload_percent', percentComplete);
      },
    }).then((r) => {
      commit('update_crew_ton_data', r.data);
      commit('set_upload_percent', 0);
      return true;
    }).catch((er) => {
      commit('set_upload_percent', 0);
      AlertService.responseAlertMessage(er, 'Replace ton file');
      return false;
    });
  },

  setTonPayloadRank({commit}, payload) {
    commit('set_ton_payload_rank', payload);
  },

  resetCrewTon({commit}) {
    return commit('reset_crew_ton');
  },

  resetCrewTons({commit}) {
    // console.log('This is reset crew tons');
    return 'reset crew tons';
  },

  resetFormObjCrewKeys({commit}) {
    commit('reset_form_obj_crew_keys');
  },

  resetFormDataVesselTon({commit}) {
    commit('reset_form_data_vessel_ton');
  },

  resetFormTonPayload({commit}) {
    commit('reset_form_ton_payload');
  },

  resetFormNewCrewTon({commit}) {
    commit('reset_form_new_crew_ton');
  },

  resetFormTonUploadReplaceFile({commit}) {
    commit('reset_form_ton_upload_replace_file');
  },
};

/** getters **/
const getters = {
  crewTon: state => state.crewTon,
  crewTons: state => state.crewTons,
  formObjCrewKeys: state => state.formObjCrewKeys,
  formDataVesselTon: state => state.formDataVesselTon,
  formTonPayload: state => state.formTonPayload,
  formNewCrewTon: state => state.formNewCrewTon,
  formTonUploadReplaceFile: state => state.formTonUploadReplaceFile,
  isSearchingCrew: state => state.isSearchingCrew,
  downloadPercent: state => state.downloadPercent,
  uploadPercent: state => state.uploadPercent,
  crewTonId: state => state.crewTonId,
};

/** export **/
export default {state, actions, mutations, getters};
